import {useContext, useRef} from 'react'

import {useDecision} from '@s-ui/pde'
import Context from '@s-ui/react-context'
import {useRouter} from '@s-ui/react-router'
import {useMessagingThirdPartyContext} from '@adv-mt/mt-messaging'
import {useAnalyticsTrack} from '@adv-mt/mt-tracking-use-analytics'

import {PATH_NAMES} from '../../../../../config/index.js'

const CHAT_IO_BUTTON_CLICKED = 'Chat IO Button Clicked'
const ERROR_TOAST_TYPE = 'error'

export const useNavigationC2bCreateAppointment = () => {
  const {push} = useRouter()
  const {adsList, showResultToast} = useMessagingThirdPartyContext()
  const {track} = useAnalyticsTrack()

  // navigation can be stored in closures created in earlier renders, so read adsList through a ref
  const adsListRef = useRef(adsList)
  adsListRef.current = adsList

  const {domain, i18n} = useContext(Context)
  const config = domain.get('config')
  const {C2B_ORIGINS} = config.get('c2b')
  const {C2B_FLOW_BY_ORIGINS} = config.get('tracking')

  const {enabled: isChangePostalCodeEnabled} = useDecision('ff_web_cnet_c2b_change_postal_code')

  const navigation = async interactionUrl => {
    const {searchParams} = new URL(interactionUrl)
    const adId = searchParams.get('adId')

    const doesAdExist = adsListRef.current?.[adId] != null

    if (!doesAdExist) {
      showResultToast({
        type: ERROR_TOAST_TYPE,
        title: i18n.t('COMMON.AD_NOT_AVAILABLE_TITLE_NOTIFICATION')
      })
      return
    }

    const [instantOfferError] = await domain.get('get_instant_offer_by_ad_seller_use_case').execute({adId})
    if (instantOfferError && !isChangePostalCodeEnabled) {
      showResultToast({
        type: ERROR_TOAST_TYPE,
        title: i18n.t('COMMON.ERROR_HAPPENED_GENERIC')
      })
      return
    }

    track({
      event: CHAT_IO_BUTTON_CLICKED,
      data: {
        products: [{id: adId, category: 'ads', price: 0, quantity: 0}],
        c2b_flow: C2B_FLOW_BY_ORIGINS[C2B_ORIGINS.CHAT]
      }
    })

    push(`/${PATH_NAMES.INSTANT_OFFER.COCHES}/?adId=${adId}&origin=${C2B_ORIGINS.CHAT}`)
  }

  return navigation
}
